import type { PulseContextProviderConfig } from '../../core/mandatory-integrations/pulse/types/index.js';

import { providerStage } from '../../core/mandatory-integrations/pulse/config.js';

export const defaultByfunnPulseConfig: PulseContextProviderConfig = {
  providerId: 'aftenposten',
  product: 'vink',
  productTag: 'vink',
  targetNewsroom: 'vink',
  stage: providerStage,
};
